import Viewer from "viewerjs";
export default {
  //隐藏event
  closeImageViewer(state, data) {
    state.imageViewer.showImages = false;
  },
  //打开event
  opendImageViewer(state, data) {
    function isCanPreview(name) {
      let fileType = name
        .split(".")
        .pop()
        .toLowerCase();

      if (state.imageViewer.canPreview.indexOf(fileType) > -1) {
        return false;
      } else {
        return true;
      }
    }
    state.imageViewer.docPreviewList = data.docList.filter(item => {
      return !isCanPreview(item.documentName);
    });
    let imgIndex = 0;
    state.imageViewer.docPreviewList.forEach((item, index) => {
      if (data.imgId == item.id) imgIndex = index;
    });

    state.pdfViewer.showPdf = false;
    state.imageViewer.showImages = true;
    //是否展示table数据
    if (data.showTable) {
      state.imageViewer.showTable = data.showTable;
    } else {
      state.imageViewer.showTable = false;
    }

    if (!state.imageViewer.Viewers) {
      //获取图片展示的数据
      state.imageViewer.options.viewed = function(event) {
        state.imageViewer.currentPreviewDocument = [
          state.imageViewer.docPreviewList[event.detail.index]
        ];
      };
      //初始化
      state.imageViewer.Viewers = new Viewer(
        document.getElementById("ImagesViewer"),
        state.imageViewer.options
      );
    }
    data.$this.$nextTick(function() {
      state.imageViewer.Viewers.update();
      state.imageViewer.Viewers.view(imgIndex);
    });
  },
  //销毁event
  destroyImageViewer(state, data) {
    if (state.imageViewer.Viewers) {
      state.imageViewer.Viewers.destroy();
      state.imageViewer.Viewers = "";
    }
  },

  //pdf 预览
  opendPdfViewer(state, data) {
    state.imageViewer.showImages = false;
    state.pdfViewer.pdfUrl = data.fileUrl;
    state.pdfViewer.showPdf = true;
    state.pdfViewer.currentPreviewDocument = data.rowData;
  },
  closePdfViewer(state, data) {
    state.pdfViewer.showPdf = false;
  },
  resetCasesQuery(state, data) {
    state.caseState.pageData.current = 1;
    state.caseState.searchData = {
      current: 1,
      size: state.caseState.pageData.size,
      operatorId: null,
      insureName: "",
      caseNo: "",
      caseState: "",
      caseType: "",
      startDay: "",
      endDay: "",
      entrustTimeStart: "",
      entrustTimeEnd: "",
      type: 1 //0 - 作业方，1 - 委托方
    };
  },
  resetPendingQuery(state, data) {
    state.casePendingState.pageData.current = 1;
    state.casePendingState.searchData = {
      current: 1,
      size: state.casePendingState.pageData.size,
      companyId: null,
      insureName: "",
      caseType: ""
    };
  },
  resetHandledQuery(state, data) {
    state.caseHandledState.pageData.current = 1;
    state.caseHandledState.searchData = {
      current: 1,
      size: state.caseHandledState.pageData.size,
      companyId: null,
      insureName: "",
      caseNo: "",
      caseState: "",
      caseType: "",
      startDay: "",
      endDay: "",
      type: 0 //0 - 作业方，1 - 委托方
    };
  }
};
